import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Calendar } from "lucide-react";
import { trackDemoClick, trackTrialClick } from "@/lib/analytics";
import { SectionHeading } from "@/components/shared/SectionHeading";

const FinalCTA = forwardRef<HTMLElement, Record<string, never>>((_, ref) => {
  return (
    <section 
      ref={ref} 
      className="relative py-24 md:py-32 overflow-hidden hero-curve"
      style={{ background: "linear-gradient(to right, #7130A0, #ED1878)" }}
    >
      
      <div className="container relative z-10">
        <div className="max-w-3xl mx-auto text-center animate-fade-up">
          <SectionHeading variant="onGradient" className="mb-6 md:text-5xl">
            Ready to Transform Your RTO Compliance?
          </SectionHeading>
          <p className="font-carlito text-xl text-white/90 mb-10 leading-relaxed text-center">
            Join Australian RTOs who are replacing compliance chaos with a system that actually works.
            Book a personalised demo and see ComplyHub in action.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              variant="chPrimary"
              className="h-12 px-8"
              asChild
            >
              <a 
                href="/trial-signup" 
                onClick={() => trackTrialClick('final_cta')}
              >
                Start Free 14-Day Trial
                <ArrowRight className="ml-2 w-5 h-5" />
              </a>
            </Button>
            <Button 
              variant="chOutlineOnDark"
              size="lg" 
              className="h-12 px-8"
              asChild
            >
              <Link 
                to="/demo#book"
                onClick={() => trackDemoClick('final_cta')}
              >
                <Calendar className="mr-2 w-5 h-5" />
                Book a Demo
              </Link>
            </Button>
          </div>
          
          <p className="mt-8 text-white/70 text-sm font-carlito">
            Free 14-day trial • No credit card required • See results in 30 minutes
          </p>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-ch-cyan/20 rounded-full blur-3xl" />
      <div className="absolute top-0 right-0 w-48 h-48 bg-ch-fuchsia/20 rounded-full blur-3xl" />
    </section>
  );
});

FinalCTA.displayName = "FinalCTA";

export default FinalCTA;
